module.exports = __webpack_public_path__ + "f64731696c57c039fec743c5580d6040.html";


//////////////////
// WEBPACK FOOTER
// ./src/index.html
// module id = 141
// module chunks = 2